<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <strong>Edit service Request</strong>
            <eb-button
              classic="mr-1 btn-primary"
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('edit', e)"
            >
            </eb-button>
          </div>

          <b-row>
            <b-col md="4">
              <span>Category</span>
            </b-col>
            <b-col md="8">
              <c-input
                inputType="text"
                lableText="Category"
                v-model="itemObj.name"
              />
            </b-col>
          </b-row>
          <b-row v-if="userRole === 'Tenant' || userRole === 'Partner'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.scope"
                  :options="scope1Options"
                  placeholder="Edit Scope"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="userRole === 'Admin'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.scope"
                  :options="scopeOptions"
                  placeholder="Edit Scope"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <span>Description</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-textarea
                  v-model="itemObj.description"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Severity</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.severity"
                  :options="severityOptions"
                  placeholder="Edit Severity"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Status</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.status"
                  :options="statusOptions"
                  placeholder="Edit Status"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <b-col md="12">
            <div class="text-center">
              <eb-button
                class="btn"
                classic="mr-1 btn-primary"
                text="Update"
                @click.prevent="handleSubmit"
              ></eb-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";

export default {
  name: "editrequest",
  components: {
    ebButton,
    cInput,
    ebSelect,
    servicerequestdetails,
  },
  data: () => {
    return {
      show: true,
      scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
      scopeOptions: ["TENANT"],
      statusOptions: ["Active", "Inactive"],
      severityOptions: ["Low", "Medium", "High", "Critical"],
      scope: "",
      status: "",
      name: "",
      severity: "",
      description: "",
    };
  },
  props: {
    itemObj: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    handleSubmit() {
      let dataObj;
      dataObj = {
        id: this.itemObj.id,
        data: {
          scope: this.itemObj.scope,
          name: this.itemObj.name,
          severity: this.itemObj.severity,
          description: this.itemObj.description,
          status: this.itemObj.status,
        },
      };
      this.$store
        .dispatch("servicerequest/updateCategory", dataObj)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Request updated successfully!!",
            type: "success",
          });
          this.$emit("edit", {});
          this.$store.dispatch("servicerequest/fetchServicerequestList");
        });
    },
  },
  async mounted() {
    console.log("hai", this.itemObj);
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
